import req from "../methods/req"
import method from '../methods/method'

//获取拜访设置
export const getVisitConfig = function (data){
    return req({
        url:'/manage/crm.visit/getVisitConfig',
        ...data
    })
}

//设置全局时间
export const saveWholeVisitConfig = function (data){
    return req({
        url:'/manage/crm.visit/saveWholeVisitConfig',
        ...data
    })
}

//拜访列表
export const getVisitConfigList = function (data){
    return method.get_list({
        url: '/manage/crm.visit/getVisitConfigList',
        ...data
    })
}

//设置拜访规则(新增、编辑)
export const saveVisitTimeConfig = function (data){
    return req({
        url:'/manage/crm.visit/saveVisitTimeConfig',
        ...data
    })
}

//规则状态修改
export const changeVisitConfigStatus = function (data){
    return req({
        url:'/manage/crm.visit/changeVisitConfigStatus',
        ...data
    })
}

//删除拜访规则
export const delVisitConfig = function (data){
    return req({
        url:'/manage/crm.visit/delVisitConfig',
        ...data
    })
}

//获取拜访规则详情
export const getVisitConfigDetail = function (data){
    return req({
        url:'/manage/crm.visit/getVisitConfigDetail',
        ...data
    })
}

//获取拜访类型
export const getTypeSelect = function (data){
    return req({
        url:'/manage/crm.visit/getTypeSelect',
        ...data
    })
}



